export const PLAYER_STATUS_MAP = new Map([
  ['pending', 'Pending'],
  ['ready', 'Ready'],
  ['stop', 'Stop'],
]);
